import { configureStore } from "@reduxjs/toolkit";

import bookingReducer from "./reducers/booking";
import uiReducer from "./reducers/ui";
import loadingReducer from "./reducers/loading";
import recaptchaReducer from "./reducers/recaptcha";

const store = configureStore({
  reducer: { booking: bookingReducer, ui: uiReducer, loading: loadingReducer, recaptcha: recaptchaReducer },
  devTools: window.devToolsExtension,
});

export default store;
